module.exports = __webpack_public_path__ + "02_medium_gold.04b5fdc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_medium_gold.png
// module id = 0Szn
// module chunks = 0